import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserContext } from "@/components/User";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { fetchRecommendedJobRequestsByProfile } from "@/data/job-requests";
import { useFetcher } from "@/hooks/http";
import { JobsWidget } from "@/views/JobRequests";

interface IRecommendedJobsWidgetProps {
  record: IConsultantProfile;
}

export const RecommendedJobsWidget: FC<IRecommendedJobsWidgetProps> = ({ record }) => {
  const { contextCompany } = useContext(UserContext);

  const { t } = useTranslation("session");

  const recommendedJobsFetcher = useFetcher(
    fetchRecommendedJobRequestsByProfile,
    { profileId: record.id, companyId: contextCompany && contextCompany.id },
    [record.id, contextCompany],
  );

  if (!recommendedJobsFetcher.payload || !recommendedJobsFetcher.payload.content.length) {
    return null;
  }

  return (
    <JobsWidget
      header={t("CONSULTANT_PROFILES.DETAIL.SIDEBAR.RECOMMENDED_JOBS_HEADER")}
      jobs={recommendedJobsFetcher.payload.content}
    />
  );
};
